import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  // public isAlertActive: Subject<boolean> = new Subject();

  constructor(private restService: RestService) { }

  public showAlert(alertContent): void {
    this.restService.getAlert().subscribe(result => {
      const alertKey = result[0].key;
      alertContent.status = true;
      console.log(alertContent);
      this.restService.updateAlert(alertContent, alertKey);
      // setTimeout(() => {
      //   this.closeAlert(alertContent, alertKey);
      // }, 4000);
    });
  }

  private closeAlert(alertContent, alertKey): void {
    alertContent.status = false;
    this.restService.updateAlert(alertContent, alertKey);
  }
}
